import React from 'react';

const NewsletterSuccess = () => (
  <>
    <img
      height="1"
      width="1"
      style={{ display: 'none' }}
      alt=""
      src="https://analytics.twitter.com/i/adsct?txn_id=o15vq&p_id=Twitter&tw_sale_amount=0&tw_order_quantity=0"
    />
    <img
      height="1"
      width="1"
      style={{ display: 'none' }}
      alt=""
      src="//t.co/i/adsct?txn_id=o15vq&p_id=Twitter&tw_sale_amount=0&tw_order_quantity=0"
    />
    <img
      height="1"
      width="1"
      style={{ display: 'none' }}
      alt=""
      src="https://dc.ads.linkedin.com/collect/?pid=490945&conversionId=757425&fmt=gif"
    />
  </>
);

export default NewsletterSuccess;
